<script>
import { defineComponent } from 'vue'
//component
import Topbar from './Topbar.vue'
export default defineComponent({
    components: {
        Topbar
    },
    props: {
        title: { type: String, default: '' },
    },
    setup: (props, ctx) => {
        const onClickBack = () => {
            ctx.emit("clickBack")
        }

        return {
            onClickBack
        }
    },
})
</script>
<template>
    <div class="bg-a-gray-f1f1f1">
        <div class="max-width-page mx-auto bg-a-gray-f1f1f1 min-h-screen page">
            <Topbar :title=title @clickBack="onClickBack()"></Topbar>
            <slot></slot>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import '../../style/base.scss';

    .max-width-page {
        max-width: $max-width-mobile;
    }
</style>